import { render, staticRenderFns } from "./DialogDel.vue?vue&type=template&id=05144ca7&"
import script from "./DialogDel.vue?vue&type=script&lang=js&"
export * from "./DialogDel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports